var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.298,
    height: 58.378,
    viewBox: "0 0 97.298 58.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(112,112,112,0.7);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.009,74.379H29.8V71.6h54.21A12.5,12.5,0,0,0,84.6,46.61a1.39,1.39,0,0,1-1.28-1.737A20.826,20.826,0,0,0,44.36,30.661a1.39,1.39,0,0,1-2.338.278A13.887,13.887,0,0,0,18.254,44.7a1.39,1.39,0,0,1-1.261,1.9,12.51,12.51,0,0,0,.3,25h8.166v2.78H17.289a15.283,15.283,0,0,1-2.2-30.407,16.487,16.487,0,0,1-.582-4.342,16.68,16.68,0,0,1,28.3-11.954A23.612,23.612,0,0,1,86.788,39.629,23.089,23.089,0,0,1,86.362,44a15.282,15.282,0,0,1-2.353,30.382Z",
    transform: "translate(-2.003 -16.002)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.29,37.29H58.51A12.524,12.524,0,0,0,46,24.78V22A15.307,15.307,0,0,1,61.29,37.29Z",
    transform: "translate(15.156 -13.662)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c8149d4b4b08bde3f2d5aff874b32bdf.svg";
export { ForwardRef as ReactComponent };